/**
 * adminNav.js — Admin/danisman kenar cubugu menu AGACI ve saf yardimcilari.
 *
 * AdminLayout.jsx'ten ayrildi (25 Agustos 2026): menu agaci ve aktiflik /
 * otomatik-acilma hesabi saf veri + saf fonksiyon oldugu icin bilesenden
 * bagimsiz test edilebilir olmali. AdminLayout yalnizca RENDER eder.
 *
 * Buradaki her sey saftir — React, router veya DOM'a bagimli degildir.
 */

import {
  Users,
  BookOpen,
  ScrollText,
  Award,
  MessageSquare,
  CreditCard,
  Video,
  Users2,
  Plane,
  FileText,
  Star,
  Megaphone,
  Calculator,
  Tag,
  BarChart3,
  ShieldAlert,
  ShieldCheck,
  Shield,
  Bug,
  UserCog,
  Scale,
  Database,
  Bell,
  Sparkles,
  Smartphone,
  BadgeCheck,
  CalendarClock,
  TrendingUp,
  Percent,
  Home,
  PieChart,
  Coffee,
  Link2,
  FileSpreadsheet,
  Landmark,
} from 'lucide-react';

// ── Navigation structure ──────────────────────────────────────────────────────

// NOT: "Genel Bakis" (id 'dashboard', path '/admin') girdisi 25 Agustos 2026'da
// menuden CIKARILDI — '/admin' artik Danisman Ana Sayfasi'ni aciyor (bkz.
// App.js). Sayfa ve 'admin.nav.dashboard' i18n anahtari SILINMEDI; anahtari
// birkac sayfa hala breadcrumb etiketi olarak kullaniyor.
export const NAV = [
  {
    id: 'education',
    icon: BookOpen,
    labelKey: 'admin.nav.education',
    children: [
      { id: 'courses', path: '/admin/courses', icon: BookOpen, labelKey: 'admin.nav.courses' },
      { id: 'vimeo', path: '/admin/vimeo', icon: Video, labelKey: 'admin.nav.vimeo' },
      { id: 'reviews', path: '/admin/reviews', icon: Star, labelKey: 'admin.nav.reviews' },
    ],
  },
  {
    id: 'students',
    icon: Users,
    labelKey: 'admin.nav.students',
    children: [
      { id: 'students-list', path: '/admin/students', icon: Users, labelKey: 'admin.nav.studentsPage' },
      { id: 'exam-groups', path: '/admin/exam-groups', icon: Users2, labelKey: 'admin.nav.examGroups' },
      { id: 'cabin-crew-groups', path: '/admin/cabin-crew-groups', icon: Users2, labelKey: 'admin.nav.cabinCrewGroups' },
    ],
  },
  {
    // Danışman/CRM ile ilgili maddeler (eskiden "students" grubunun içindeydi)
    // ayrı bir üst gruba toplandı — Faz 0 gruplama, yeni sayfa/route eklenmedi.
    // Faz 1-3'te bu gruba yeni danışman sayfaları eklenecek.
    id: 'danisman-data',
    icon: Users2,
    labelKey: 'admin.nav.danismanData',
    // 25 Agustos 2026: duz duran 11 madde 4 alt drawer'a bolundu ("cok fazla
    // menu oldu" geri bildirimi). Madde SAYISI ve id'leri degismedi — yalnizca
    // bir seviye derinlestiler. id'ler data-testid'e (admin-nav-${id}) girdigi
    // icin degistirilmemeli.
    children: [
      {
        id: 'danisman-gunluk-is',
        icon: Home,
        labelKey: 'admin.nav.danismanGunlukIs',
        children: [
          { id: 'danisman-ana-sayfa', path: '/danisman', icon: Home, labelKey: 'admin.nav.danismanAnaSayfa', exact: true },
          { id: 'cockpit', path: '/admin/cockpit', icon: Users2, labelKey: 'admin.nav.danismanCockpit' },
        ],
      },
      {
        id: 'danisman-data-onay',
        icon: Database,
        labelKey: 'admin.nav.danismanDataOnay',
        children: [
          { id: 'leads', path: '/admin/leads', icon: Database, labelKey: 'admin.nav.dataManagement' },
          { id: 'satis-onay', path: '/admin/satis-onay', icon: BadgeCheck, labelKey: 'admin.nav.satisOnay' },
        ],
      },
      {
        id: 'danisman-raporlar',
        icon: BarChart3,
        labelKey: 'admin.nav.danismanRaporlar',
        children: [
          { id: 'ciro-dashboard', path: '/admin/ciro-dashboard', icon: TrendingUp, labelKey: 'admin.nav.ciroDashboard' },
          { id: 'danisman-istatistik', path: '/danisman/istatistik', icon: PieChart, labelKey: 'admin.nav.danismanIstatistik' },
          { id: 'satis-raporlama', path: '/admin/satis-raporlama', icon: BarChart3, labelKey: 'admin.nav.satisRaporlama' },
        ],
      },
      {
        id: 'danisman-ekip',
        icon: UserCog,
        labelKey: 'admin.nav.danismanEkip',
        children: [
          { id: 'personel-yonetimi', path: '/admin/personel-yonetimi', icon: UserCog, labelKey: 'admin.nav.personelYonetimi' },
          { id: 'danisman-yonetimi', path: '/admin/danismanlar', icon: UserCog, labelKey: 'admin.nav.danismanYonetimi' },
          { id: 'prim-kurallari', path: '/admin/prim-kurallari', icon: Percent, labelKey: 'admin.nav.primKurallari' },
          { id: 'mesai-mola', path: '/danisman/mesai-mola', icon: Coffee, labelKey: 'admin.nav.mesaiMolaTakip' },
          { id: 'izin-talepleri', path: '/admin/izin-talepleri', icon: CalendarClock, labelKey: 'admin.nav.izinTalepleri' },
        ],
      },
    ],
  },
  {
    id: 'cabin-academy',
    icon: Plane,
    labelKey: 'admin.nav.cabinAcademy',
    children: [
      { id: 'cabin-hub', path: '/admin/cabin-academy', icon: Plane, labelKey: 'admin.nav.cabinHub' },
      { id: 'cabin-curriculum', path: '/admin/cabin-curriculum', icon: BookOpen, labelKey: 'admin.nav.cabinCurriculum' },
    ],
  },
  {
    id: 'documents',
    icon: FileText,
    labelKey: 'admin.nav.documents',
    children: [
      { id: 'certificates', path: '/admin/certificates', icon: Award, labelKey: 'admin.nav.certificates' },
      { id: 'cert-print', path: '/admin/cert-print', icon: Award, labelKey: 'admin.nav.certPrint' },
      { id: 'dijital-rozet', path: '/admin/dijital-rozet', icon: Award, labelKey: 'admin.nav.dijitalRozet' },
      { id: 'docs', path: '/admin/documents', icon: FileText, labelKey: 'admin.nav.documentsList' },
      { id: 'contracts', path: '/admin/contracts', icon: ScrollText, labelKey: 'admin.nav.contracts' },
      { id: 'kvkk', path: '/admin/kvkk-requests', icon: ShieldAlert, labelKey: 'admin.nav.kvkk' },
      { id: 'legal-content', path: '/admin/legal-content', icon: ShieldCheck, labelKey: 'admin.nav.legalContent' },
      { id: 'geo-content', path: '/admin/geo-content', icon: Sparkles, labelKey: 'admin.nav.geoContent' },
    ],
  },
  {
    id: 'finance',
    icon: CreditCard,
    labelKey: 'admin.nav.finance',
    children: [
      { id: 'accounting', path: '/admin/accounting', icon: Calculator, labelKey: 'admin.nav.accounting' },
      { id: 'moka-queue', path: '/admin/moka-queue', icon: Link2, labelKey: 'admin.nav.mokaQueue' },
      { id: 'bank-matching-pool', path: '/admin/bank-matching-pool', icon: Landmark, labelKey: 'admin.nav.bankMatchingPool' },
      { id: 'invoices', path: '/admin/invoices', icon: FileText, labelKey: 'admin.nav.invoices' },
      { id: 'muhasebe-listesi', path: '/admin/muhasebe-listesi', icon: FileSpreadsheet, labelKey: 'admin.nav.muhasebeListesi' },
      { id: 'parasut-mapping', path: '/admin/parasut-mapping', icon: Calculator, labelKey: 'admin.nav.parasutMapping' },
      { id: 'legal', path: '/admin/legal', icon: Scale, labelKey: 'admin.nav.legal' },
      { id: 'campaigns', path: '/admin/campaigns', icon: Megaphone, labelKey: 'admin.nav.campaigns' },
      { id: 'reports', path: '/admin/reports', icon: BarChart3, labelKey: 'admin.nav.reports' },
    ],
  },
  {
    id: 'system',
    icon: ShieldCheck,
    labelKey: 'admin.nav.system',
    children: [
      { id: 'messages', path: '/admin/messages', icon: MessageSquare, labelKey: 'admin.nav.messages' },
      { id: 'announcements', path: '/admin/announcements', icon: Megaphone, labelKey: 'admin.nav.announcements' },
      { id: 'notification-jobs', path: '/admin/notification-jobs', icon: Bell, labelKey: 'admin.nav.notificationJobs' },
      { id: 'app-version', path: '/admin/app-version', icon: Smartphone, labelKey: 'admin.nav.appVersion' },
      { id: 'logs', path: '/admin/logs', icon: ScrollText, labelKey: 'admin.nav.logs' },
      { id: 'active-sessions', path: '/admin/active-sessions', icon: Shield, labelKey: 'admin.nav.activeSessions' },
      { id: 'anomalies', path: '/admin/anomalies', icon: ShieldAlert, labelKey: 'admin.nav.anomalies', _badgeKey: 'anomaly' },
      { id: 'bug-reports', path: '/admin/bug-reports', icon: Bug, labelKey: 'admin.nav.bugReports' },
      { id: 'definitions', path: '/admin/definitions', icon: Tag, labelKey: 'admin.nav.definitions' },
    ],
  },
];

export const DANISMAN_NAV = [
  { id: 'danisman-ana-sayfa', path: '/danisman', icon: Home, labelKey: 'admin.nav.danismanAnaSayfa', exact: true },
  { id: 'cockpit', path: '/admin/cockpit', icon: Users2, labelKey: 'admin.nav.danismanCockpit' },
  { id: 'ciro-dashboard', path: '/admin/ciro-dashboard', icon: TrendingUp, labelKey: 'admin.nav.ciroDashboard' },
  { id: 'danisman-istatistik', path: '/danisman/istatistik', icon: PieChart, labelKey: 'admin.nav.danismanIstatistik' },
  // Mesai & Mola: danisman rolunde de TUM ekip gorunur (saat damgasi,
  // para/lead degil) — bilincli izolasyon istisnasi, bkz. sayfa docstring'i.
  { id: 'mesai-mola', path: '/danisman/mesai-mola', icon: Coffee, labelKey: 'admin.nav.mesaiMolaTakip' },
];

export function navForRole(role) {
  if (role === 'danisman') return DANISMAN_NAV;
  return NAV;
}

/**
 * Menu hesabi icin adres normalizasyonu.
 *
 * '/admin' kok route'u 25 Agustos 2026'da Danisman Ana Sayfasi'ni gostermeye
 * basladi (bkz. App.js) ama menude '/admin' path'li bir yaprak KALMADI ("Genel
 * Bakis" cikarildi). Normalizasyon olmadan '/admin' acildiginda hicbir yaprak
 * eslesmez: tum drawer'lar kapali gelir ve hicbir madde vurgulanmaz — AYNI
 * ekran '/danisman' uzerinden acildiginda ise duzgun vurgulanirdi.
 *
 * Cozum olarak yalnizca TAM '/admin' string'i '/danisman'a esitlenir. Bilerek
 * alias yontemi secildi (yaprak girdisine 'matchPaths' eklemek yerine): '/admin'
 * TUM admin sayfalarinin oneki oldugu icin onek eslesmesine sokulursa menude
 * yapragi olmayan her '/admin/*' sayfasinda "Gunluk Is" drawer'i bosuna
 * acilirdi. Tam esitlik bu yan etkiyi tasimaz.
 *
 * Yalnizca MENU icindir; App.js'teki route ve rol kapisi bundan etkilenmez.
 */
export const NAV_PATH_ALIASES = {
  '/admin': '/danisman',
};

export function normalizeNavPath(pathname) {
  return NAV_PATH_ALIASES[pathname] || pathname;
}

/**
 * Tek bir menu maddesinin (yaprak) kendi path'i geregi aktif olup olmadigi.
 *
 * `exact` desteği: bazi path'ler baska bir maddenin oneki olabilir (ör.
 * '/danisman' ile '/danisman/istatistik' ve '/danisman/mesai-mola'). exact
 * isaretli maddeler TAM eslesme ister; digerlerinde davranis onek eslesmesi
 * (startsWith) olarak KALDI. Bu yardimci fonksiyon her seviyede ayni sekilde
 * kullanilir — `exact` ikinci (ve daha derin) seviyede de gecerlidir.
 */
export function isLeafActive(item, pathname) {
  if (!item.path) return false;
  // Duz startsWith DEGIL: '/admin/legal' ham onek olarak '/admin/legal-content'
  // adresine de uyuyordu ve iki madde ayni anda vurgulu goruntuleniyordu.
  // isPathWithin path SINIRINA bakar, o yuzden yalnizca gercek alt sayfalar uyar.
  return item.exact ? pathname === item.path : isPathWithin(pathname, item.path);
}

/**
 * Madde ya da HERHANGI bir torunu aktif mi (ozyinelemeli).
 *
 * Ic ice drawer'larda "torun aktifse dedeyi de ac" davranisi buna dayanir:
 * tek seviyelik `children.some(startsWith)` hesabi bir alt drawer'in icindeki
 * aktif sayfayi goremez ve kullanici bulundugu sayfayi menude bulamazdi.
 */
export function isBranchActive(item, pathname) {
  if (isLeafActive(item, pathname)) return true;
  if (item.children) return item.children.some((child) => isBranchActive(child, pathname));
  return false;
}

// Path SINIRI farkindaligiyla onek eslesmesi: '/admin/lead', '/admin/leads'in
// oneki SAYILMAZ. (Duz startsWith bu ikisini karistirirdi.)
export function isPathWithin(pathname, path) {
  if (!path) return false;
  return pathname === path || pathname.startsWith(path.endsWith('/') ? path : `${path}/`);
}

/**
 * Hangi gruplarin KENDILIGINDEN acilacagini hesaplar.
 *
 * Kural: mevcut adrese uyan EN UZUN yaprak path'i bulunur, o yaprağa giden
 * tum ATA id'leri dondurulur. "En uzun eslesme" kurali iki ayri sorunu birden
 * cozer:
 *   1) '/danisman' (Gunluk Is) ile '/danisman/mesai-mola' (Ekip Yonetimi)
 *      cakismaz — mesai-mola sayfasindayken yalnizca Ekip drawer'i acilir,
 *      Gunluk Is bosuna acilmaz.
 *   2) Menude YER ALMAYAN bir alt sayfada (ör. '/danisman/ogrenci/123')
 *      en uzun eslesme '/danisman' olur ve kullanici en azindan dogru ust
 *      grubu acik gorur. Tek seviyeli eski kodda bu davranis vardi; salt
 *      `exact` esitligine dayanan bir hesap onu KAYBEDERDI.
 *
 * Dikkat: bu yalnizca ACILMA icindir. Hangi maddenin AKTIF (vurgulu) oldugu
 * ayri bir hesap (isLeafActive) ve `exact` orada baglayicidir.
 */
export function autoOpenGroupIds(items, pathname) {
  let bestLen = -1;
  let bestTrail = [];
  const walk = (list, trail) => {
    list.forEach((item) => {
      if (item.children) {
        walk(item.children, [...trail, item.id]);
      } else if (isPathWithin(pathname, item.path) && item.path.length > bestLen) {
        bestLen = item.path.length;
        bestTrail = trail;
      }
    });
  };
  walk(items, []);
  return new Set(bestTrail);
}
